import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 64775 58078"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#000;stroke-width:717.819}.fil0{fill:#1c1b17}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528323623696">
        <path
          d="M5711 4831h53354v30998H5711V4831zm-211 31418h53775c117 0 210-94 210-210V4621c0-116-93-210-210-210H5500c-116 0-210 94-210 210v31418c0 116 94 210 210 210z"
          className="fill stroke1"
          style={{
            strokeWidth: 717.819,
          }}
        />
        <path
          d="M60734 39494h-2393c-147 0-266-119-266-265 0-147 119-267 266-267h2393c72 0 137 29 185 75 50 49 82 117 82 192 0 146-120 265-267 265zm0-982h-2393c-129 0-249 35-353 93-204 116-345 329-362 575-1 17-2 33-2 49 0 394 322 716 717 716h2393c396 0 717-322 717-716 0-396-321-717-717-717z"
          style={{
            fill: "#2b2a29",
            // stroke: "#2b2a29",
            strokeWidth: 717.819,
          }}
          className="fill"
        />
        <path
          d="M27640 41381H1283c-261 0-474-212-474-473V1282c0-260 213-473 474-473h62210c131 0 250 54 335 141 85 85 138 203 138 333v39625c0 261-213 473-473 473H37135c125 0 226 101 226 225v225h26132c509 0 923-414 923-923V1282c0-481-371-878-843-918-26-3-53-5-80-5H1283c-510 0-924 414-924 924v39625c0 509 414 923 924 923h26132v-225c0-124 100-225 225-225zM41514 54361c0 178-102 322-225 322h5987c633 0 1407 739 1407 1602v791H16093v-791c0-252 66-491 176-707 263-523 782-895 1230-895h5990c-101 0-188-94-216-230-29-138 10-285 94-361l55-52h-5923c-859 0-1857 981-1857 2245v1112c0 51 9 98 24 141 36 107 113 181 201 181h33041c124 0 225-144 225-322v-1112c0-1264-998-2245-1857-2245h-5923l38 36c73 53 123 162 123 285z"
          className="fill"
        />
        <path
          d="M37361 41902c0-287-101-522-226-522h-9495c-125 0-225 235-225 522v7579l103-155c37-54 78-84 122-84h225v-6817h9045v6817h225c44 0 85 30 122 84l104 155v-7579zM40521 53946H24254l3453-3714h9362l3452 3714zm-3386-4465h-9495c-44 0-85 21-122 60l-103 111-212 229-3781 4065-55 60c-84 90-123 262-94 423 28 159 115 269 216 269h17800c124 0 225-169 225-376 0-145-50-272-123-334l-38-42-3992-4294-104-111c-36-39-78-60-122-60z"
          className="fill"
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
